import { FC } from 'react';
import { ScanHistory } from './ScanHistory/ScanHistory';

export const ScanHistoryPage: FC = () => {
  return <ScanHistory />;
};
